import {
  SET_COLLEC_TDATA,
  SET_PICKING_TDATA,
  SET_PICKING_TDATA_KEY,
  DELETE_PICKING_TDATA
} from '../type'

const state = {
  CollData: [], // 收货表单数据
  PickingData: [] // 拣货表单数据
}

const mutations = {
  [SET_COLLEC_TDATA](state, data) { // 设置表单数据

  },
  [SET_PICKING_TDATA_KEY](state, data) { // 设置表单数据
    if (Array.isArray(data)) {
      data.forEach(e => { state.PickingData[e.index][e.key] = e.value })
    } else {
      state.PickingData[data.index][data.key] = data.value
    }
  },
  [SET_PICKING_TDATA](state, data) {
    state.PickingData = data
  },
  [DELETE_PICKING_TDATA](state, index) {
    state.PickingData.splice(index, 1)
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/tableData.js